import React, { Component } from 'react'
import trans from 'trans'

import {
    Spinner,
    css,
    Theme,
    Icon,
    Grid,
    GridCell,
    Textarea,
    TextInput,
    Button,
    DataTable,
    DataRow,
    DataCell,
    DataBody,
    DataHeader,
    Badge,
    Section,
} from "@bdfx/mergado-ui-kit"

import store from "store";
import { createToast } from "actions";
import { textToast } from "app/helpers/toast_factory";
import { superadminFindBy, publishProducts, projectId, superadminFindProjectBy, PublishType } from 'app/helpers/api';
import { AxiosResponse } from "axios";
import { URL } from "app/config/api-config";
import { ID, intboolean } from 'app/types/app-types';
import { IconRemoveBackground } from 'app/icons';
import { RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE, RENDERED_TYPE_INPAINTING, RENDERED_TYPE_OUTPAINTING, RENDERED_TYPE_UPSCALE } from 'products/types';
import { TemplateBadges } from 'template-list/template-badges';
import DoubleScrollBar from 'app/components/double-scroll-bar';
import { getAddOutpaintedSuffix, getNewSize } from 'shape-edit/forms/helpers';

type FindProjectByType = {
    id: number
    first_name: string
    last_name: string
    user_name: string
    user_email: string
    contact_email: string
    creator_id: number
    locale: string
    name: string
    shop_name: string
}

type FindByResultType = {
    content_length: number
    content_type: string
    width: number
    height: number
    image_id: number
    product_id: number | string
    project_id: number
    template_name: string
    template_type: number
    template_overscan?: number
    template_translate_x?: number
    template_translate_y?: number
    template_outpaint_over?: boolean | intboolean
    source_url: string
    original_url: string
    original_url_hash: string
    user_set_objects: string
    watermark_group_id: number
    inpainting_group_id: number
    wmgroup_image_filename: string
    wmremove_progress: string
    wmremove_status: string
    image_hash: string
    template_id: number
    is_anim_gif: intboolean
    is_collage: intboolean
    is_autocrop: intboolean
    active: intboolean
    active_from: intboolean
    active_to: intboolean
    visual_similarity_enabled: intboolean
    visual_similarity_threshold: intboolean
    visual_similarity_n: intboolean
    visual_similarity_templateids: intboolean
    effect_sensitivity: string
    size_width: number
    size_height: number
}

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
}

interface State {
    productsString: string
    imagesString: string
    imageHashesString: string
    templateId: string
    results: FindByResultType[]
    resultsProjects: FindProjectByType[]
    showSQL: boolean
    limit: number
    userEmail: string
    userName: string
    projectName: string
}

class FindBy extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            productsString: '',
            imagesString: '',
            imageHashesString: '',
            templateId: '',
            results: null,
            resultsProjects: null,
            showSQL: false,
            limit: 20,
            userEmail: '',
            userName: '',
            projectName: '',
        }
    }

    copyToClipboard = (id) => {
        const element = document.getElementById(id);
        let range, select;
        if (element) {
            if (document.createRange) {
                range = document.createRange();
                range.selectNode(element)
                select = window.getSelection();
                select.removeAllRanges();
                select.addRange(range);
                document.execCommand('copy');
                select.removeAllRanges();
            }
            store.dispatch(createToast(textToast('success', trans('copied_to_clipboard'))))
            element.focus();
        }
    }

    replaceNonNumeric = (str: string): string => {
        return str.toString().replace(/[^0-9;,\s]+/g, '')
    }

    listToArray = (str: string): string[] => {
        return str.toString().replace(/[\s;]+/g, ',').split(',').filter(v => v !== '')
    }

    handleFindBy = (productIds: string[], imageIds: string[], imageHases: string[], templateId: string, limit: number) => {
        superadminFindBy(productIds, imageIds, imageHases, templateId, limit)
            .then((response: AxiosResponse<FindByResultType[]>) => {
                this.setState({ results: response.data })
                const el = document.getElementById('results')
                if (el) {
                    el.scrollIntoView()
                }
            })
            .catch(e => {
                console.error('cannot find by', e)
            })
    }

    handleFindProjectBy = (userEmail: string, userName: string, projectName: string, limit: number) => {
        superadminFindProjectBy(userEmail, userName, projectName, limit)
            .then((response: AxiosResponse<FindProjectByType[]>) => {
                this.setState({ resultsProjects: response.data })
            })
            .catch(e => {
                console.error('cannot find by', e)
            })
    }

    publishProduct = (productIds: ID[], type: PublishType, pid: ID) => {
        publishProducts(productIds, type, pid)
            .then(response => {
                console.log(`published to ${type} for project ${pid}`, response.data)
            })
            .catch(e => {
                console.error('something went wrong', e)
            })
    }

    render() {
        const { productsString, imagesString, imageHashesString, templateId, results, resultsProjects, showSQL, userEmail, userName, projectName, limit } = this.state

        const productIds = this.listToArray(productsString)
        const imageIds = this.listToArray(imagesString)
        const imageHases = this.listToArray(imageHashesString)
        const moreConditions = templateId && (productIds.length > 0 || imageIds.length > 0)

        return (
            <React.Fragment>
                <StyledDiv>
                    <h2>Find product and images:</h2>
                    <Grid cols={'1fr 1fr'} gap={'10px'}>
                        <GridCell col={'1/-1'}>
                            <h3 className={'toggle-show'} onClick={() => this.setState({ showSQL: !showSQL })}>
                                <Icon type={showSQL ? 'chevron-up-light' : 'chevron-down-light'} text={'SQL'} textFirst={true} color={Theme.steelblue} />
                            </h3>

                            {showSQL &&
                                <div>
                                    <div className={'shadow-box'} style={{ padding: '20px' }}>
                                        <div id={'sql-code'}>
                                            SELECT <br />
                                            <span className={'p'}>images_products.project_id, images_products.image_id, images_products.product_id, products.template_id, images.content_type, images.content_length, </span><br />
                                            <span className={'p'}>concat('{URL.laravelBase}get-source-image/', images_products.project_id, '/', images.hash) as source_url,</span><br />
                                            <span className={'p'}>concat('{URL.laravelBase}get-bgremoved-image/', images_products.project_id, '/', images.hash, '/', products.rendered_sensitivity) as bgremoved_url</span><br />
                                            FROM images_products<br />
                                            JOIN images on images.id = images_products.image_id<br />
                                            JOIN products on products.id = images_products.product_id<br />
                                            WHERE<br />
                                            {templateId && <span className={'p'}> products.template_id = {templateId} </span>}
                                            {moreConditions && <>OR (<br /></>}
                                            {productIds.length > 0 && <span
                                                className={'p'}> images_products.product_id IN ( {productIds.join(', ')} )</span>}
                                            {productIds.length > 0 && imageIds.length > 0 && <span> OR </span>}
                                            {imageIds.length > 0 &&
                                                <span className={'p'}> images_products.image_id IN ( {imageIds.join(', ')} )</span>}
                                            <br />
                                            {moreConditions && <><span>)</span><br /></>}
                                            LIMIT 20
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <Button
                                            type={'void'}
                                            size={'small'}
                                            icon={<Icon type="clipboard-light" text={trans('copy_to_clipboard')} />}
                                            onClick={() => this.copyToClipboard('sql-code')}
                                        />
                                    </div>
                                </div>
                            }
                        </GridCell>

                        <GridCell>
                            <h3>product id</h3>
                            <Textarea
                                placeholder={'1234,1235,1236,...'}
                                value={productsString}
                                multiline={true}
                                style={{ lineHeight: 'inherit' }}
                                onChange={(value) => this.setState({ productsString: this.replaceNonNumeric(value) })}
                                height={100}
                            />
                        </GridCell>
                        <GridCell>
                            <h3>image id</h3>
                            <Textarea
                                placeholder={'123,456,...'}
                                value={imagesString}
                                multiline={true}
                                style={{ lineHeight: 'inherit' }}
                                onChange={(value) => this.setState({ imagesString: this.replaceNonNumeric(value) })}
                                height={100}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>image hash</h3>
                            <Textarea
                                placeholder={'0123456abcdefg...,...,...'}
                                value={imageHashesString}
                                multiline={true}
                                style={{ lineHeight: 'inherit' }}
                                onChange={(value) => this.setState({ imageHashesString: value })}
                                height={100}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>template id</h3>
                            <TextInput
                                type={'number'}
                                value={templateId}
                                onChange={(value) => this.setState({ templateId: value })}
                                onClear={() => this.setState({ templateId: '' })}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>limit</h3>
                            <TextInput
                                type={'number'}
                                value={limit}
                                onChange={(value) => this.setState({ limit: value })}
                                onClear={() => this.setState({ limit: 20 })}
                            />
                        </GridCell>

                        <GridCell col={'1/-1'}>
                            <Button
                                type={'void'}
                                size={'small'}
                                icon={<Icon type={'search'} text={'Find by id'} />}
                                onClick={() => this.handleFindBy(productIds, imageIds, imageHases, templateId, limit)}
                            />
                        </GridCell>

                        {results &&
                            <GridCell col={'1/-1'}>
                                <DoubleScrollBar color={Theme.blue}>
                                <DataTable style={{ marginTop: '20px' }} id={'results'}>
                                    <DataHeader>
                                        <DataCell>product_id</DataCell>
                                        <DataCell>image_id</DataCell>
                                        <DataCell>template_id</DataCell>
                                        <DataCell>project_id</DataCell>
                                        <DataCell width={150}>original_url, source_url</DataCell>
                                        <DataCell>mime type, length</DataCell>
                                        <DataCell>img</DataCell>
                                    </DataHeader>
                                    <DataBody>
                                        {results.map(r => {
                                            const productIds = r.product_id.toString().split(', ')
                                            const productId = productIds[0]

                                            const nowTimestamp = new Date().getTime()

                                            const newSize = getNewSize(r.width, r.height, {width: r.size_width, height: r.size_height}, r.template_overscan, !!r.template_outpaint_over)
                                            const addSuffix = getAddOutpaintedSuffix(r.template_outpaint_over, r.template_overscan, r.template_translate_x, r.template_translate_y)
                                            const sizeString = newSize ? `${newSize.width}x${newSize.height}${addSuffix}` : `${addSuffix}`

                                            const upscaledNewUrl = `${URL.laravelBase}get-upscaled-image/${r.project_id}/${r.image_hash}?ts=${nowTimestamp}`
                                            const bgremovedNewUrl = `${URL.laravelBase}get-bgremoved-image/${r.project_id}/${r.image_hash}/${r.effect_sensitivity}?t=${nowTimestamp}`
                                            const outpaintedUrl = `${URL.laravelBase}get-outpainted-image/${r.project_id}/${r.image_hash}`
                                            const outpaintedWithSizeUrl = `${URL.laravelBase}get-outpainted-image/${r.project_id}/${r.image_hash}/${sizeString}`
                                            const wmremovedUrl = `${URL.laravelBase}get-wmremoved/${r.project_id}/${r.original_url_hash}?t=${nowTimestamp}`
                                            const wmAutoRemovedUrl = `${URL.laravelBase}get-autowmremoved/${r.project_id}/${r.original_url_hash}?t=${nowTimestamp}`
                                            const wmAutoRemovedMaskUrl = `${URL.laravelBase}get-autowmremoved-mask/${r.project_id}/${r.original_url_hash}?t=${nowTimestamp}`


                                            //nema tady byt namisto r.inpainting_group_id  group hash????
                                            const inpaintedUrl = `${URL.laravelBase}get-inpainted-image/${r.project_id}/${r.image_hash}/${r.inpainting_group_id}?t=${nowTimestamp}`


                                            const inpainterMaskUrl = `${URL.laravelBase}get-wmmask/${r.project_id}/${r.original_url_hash}?t=${nowTimestamp}`
                                            const wmgroupImageMaskUrl = `${URL.laravelBase}get-wmgroup-image-mask/${r.project_id}/${r.watermark_group_id}/${r.wmgroup_image_filename}?t=${nowTimestamp}`
                                            const wmgroupImageInpaintedUrl = `${URL.laravelBase}get-wmgroup-image-inpainted/${r.project_id}/${r.watermark_group_id}/${r.wmgroup_image_filename}?t=${nowTimestamp}`

                                            return <DataRow dataId={`${r.image_id}_${r.product_id}_${r.template_id}`} key={`${r.image_id}_${r.product_id}_${r.template_id}`}>
                                                <DataCell>
                                                    {r.product_id}

                                                    <div style={{ textAlign: 'center' }}>
                                                        <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'composer', r.project_id)}
                                                            title={`composer`}><Icon type="send-light" color={Theme.steelblue} /></span>

                                                        {r.template_type === RENDERED_TYPE_BGREMOVE &&
                                                            <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'bgremover', r.project_id)}
                                                                title={`bgremover`}><Icon type="send-light" color={Theme.blue} /></span>
                                                        }

                                                        {(r.template_type === RENDERED_TYPE_OUTPAINTING) &&
                                                            <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'outpainter', r.project_id)}
                                                                title={`outpainter`}><Icon type="send-light" color={Theme.orange} /></span>
                                                        }

                                                        {(r.template_type === RENDERED_TYPE_INPAINTING) &&
                                                            <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'inpainter', r.project_id)}
                                                                title={`inpainter`}><Icon type="send-light" color={Theme.orange} /></span>
                                                        }

                                                        <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'downloader', r.project_id)}
                                                            title={`downloader`}><Icon type="send-light" color={Theme.green} /></span>

                                                        {(r.template_type === RENDERED_TYPE_UPSCALE && r.width < 300 && r.height < 300) &&
                                                            <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'upscaler', r.project_id)}
                                                                title={`upscaler (${r.width}x${r.height})`}><Icon type="send-light" color={Theme.green} /></span>
                                                        }

                                                        {(r.template_type === RENDERED_TYPE_AUTOWMREMOVE && r.watermark_group_id && !r.user_set_objects && !r.wmgroup_image_filename) &&
                                                            <span className='clickable' onClick={(e) => this.publishProduct(productIds, 'autowmremover', r.project_id)}
                                                                title={`autowmremover group ${r.watermark_group_id}`}><Icon type="send-light" color={Theme.green} /></span>
                                                        }
                                                    </div>

                                                </DataCell>
                                                <DataCell>{r.image_id}</DataCell>
                                                <DataCell style={{ textAlign: 'center' }}>
                                                    <div>{r.template_id}</div>
                                                    <div><b>{r.template_name}</b> {r.template_type}</div>
                                                    <TemplateBadges template={r} showIcons={true} showInline={false} />
                                                </DataCell>
                                                <DataCell>{r.project_id}</DataCell>
                                                <DataCell>
                                                    {r.original_url}<br />
                                                    {r.source_url}
                                                </DataCell>
                                                <DataCell>{r.content_type} ({r.content_length}) {r.width}x{r.height}</DataCell>
                                                <DataCell>
                                                    <Grid cols={'repeat(3, 1fr)'} rows={'100px 100px'}>
                                                        <GridCell className={'center'}>
                                                            <a href={r.source_url} target={"_blank"}>
                                                                <img className={'preview-img checker'} src={r.source_url} title={'source'} /></a>
                                                        </GridCell>
                                                        <GridCell className={'center'}>
                                                            <a href={r.original_url} target={"_blank"}>
                                                                <img className={'preview-img checker'} src={r.original_url} title={'original'} />
                                                            </a>
                                                        </GridCell>
                                                        <GridCell className={'center'}>
                                                            <a href={`${URL.laravelBase}images?template_id=${r.template_id}&product_id=${productId}`} target={"_blank"}>
                                                                <img className={'preview-img checker'} src={`${URL.laravelBase}images?template_id=${r.template_id}&product_id=${productId}`} title={'fie'} />
                                                            </a>
                                                        </GridCell>
                                                        <GridCell>
                                                            <img className={'preview-img checker'} src={upscaledNewUrl} title={'upscaled'} />
                                                        </GridCell>
                                                        <GridCell>
                                                            <img className={'preview-img checker'} src={bgremovedNewUrl} title={'bgremoved'} />
                                                        </GridCell>
                                                        <GridCell>
                                                            <img className={'preview-img checker'} src={outpaintedWithSizeUrl} title={`outpainted_${r.size_width}x${r.size_height}${addSuffix}`} />
                                                        </GridCell>
                                                        <GridCell>
                                                            <img className={'preview-img checker'} src={outpaintedUrl} title={'outpainted'} />
                                                        </GridCell>
                                                        <GridCell>
                                                            <img className={'preview-img checker'} src={inpaintedUrl} title={'inpainted image'} />
                                                        </GridCell>

                                                        {r.user_set_objects &&
                                                            <React.Fragment>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={inpainterMaskUrl} title={'manually defined mask'} />
                                                                </GridCell>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={wmremovedUrl} title={'manually inpainted image'} />
                                                                </GridCell>
                                                            </React.Fragment>
                                                        }

                                                        {r.wmgroup_image_filename &&
                                                            <React.Fragment>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={wmgroupImageMaskUrl} title={`wmgroup image manually set mask, group ${r.watermark_group_id} ${r.wmremove_progress}, ${r.wmremove_status}, ${r.image_hash}`} />
                                                                </GridCell>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={wmgroupImageInpaintedUrl} title={`wmgroup image inpainted, group ${r.watermark_group_id} ${r.wmremove_progress}, ${r.wmremove_status}, ${r.image_hash}`} />
                                                                </GridCell>
                                                            </React.Fragment>
                                                        }

                                                        {r.watermark_group_id && !r.user_set_objects && !r.wmgroup_image_filename &&
                                                            <React.Fragment>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={wmAutoRemovedMaskUrl} title={`auto wmremoved mask, group ${r.watermark_group_id} ${r.wmremove_progress}, ${r.wmremove_status}, ${r.image_hash}`} />
                                                                </GridCell>
                                                                <GridCell>
                                                                    <img className={'preview-img checker'} src={wmAutoRemovedUrl} title={`auto wmremoved image, group ${r.watermark_group_id} ${r.wmremove_progress}, ${r.wmremove_status}, ${r.image_hash}`} />
                                                                </GridCell>
                                                            </React.Fragment>
                                                        }
                                                    </Grid>
                                                </DataCell>
                                            </DataRow>
                                        })}
                                    </DataBody>
                                    </DataTable>
                                    </DoubleScrollBar>
                            </GridCell>
                        }
                    </Grid>
                </StyledDiv>

                <StyledDiv style={{ marginTop: '40px' }}>
                    <h2>Find project:</h2>

                    <Grid cols={'1fr 1fr'} gap={'10px'}>
                        <GridCell>
                            <h3>user email</h3>
                            <TextInput
                                type={'search'}
                                value={userEmail}
                                onChange={(value) => this.setState({ userEmail: value })}
                                onClear={() => this.setState({ userEmail: '' })}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>user name</h3>
                            <TextInput
                                type={'search'}
                                value={userName}
                                onChange={(value) => this.setState({ userName: value })}
                                onClear={() => this.setState({ userName: '' })}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>project name</h3>
                            <TextInput
                                type={'search'}
                                value={projectName}
                                onChange={(value) => this.setState({ projectName: value })}
                                onClear={() => this.setState({ projectName: '' })}
                            />
                        </GridCell>

                        <GridCell>
                            <h3>limit</h3>
                            <TextInput
                                type={'number'}
                                value={limit}
                                onChange={(value) => this.setState({ limit: value })}
                                onClear={() => this.setState({ limit: 20 })}
                            />
                        </GridCell>

                        <GridCell col={'1/-1'}>
                            <Button
                                type={'void'}
                                size={'small'}
                                icon={<Icon type={'search'} text={'Find project'} />}
                                onClick={() => this.handleFindProjectBy(userEmail, userName, projectName, 20)}
                            />
                        </GridCell>

                        {resultsProjects &&
                            <GridCell col={'1/-1'}>
                                <DataTable style={{ marginTop: '20px' }} id={'results'}>
                                    <DataHeader>
                                        <DataCell>project id</DataCell>
                                        <DataCell>user name</DataCell>
                                        <DataCell>user email</DataCell>
                                        <DataCell>creator id</DataCell>
                                        <DataCell>locale</DataCell>
                                        <DataCell>project name</DataCell>
                                    </DataHeader>
                                    <DataBody>
                                        {resultsProjects.map(r => {
                                            return <DataRow dataId={`${r.id}`}>
                                                <DataCell>{r.id}</DataCell>
                                                <DataCell>{r.user_name}</DataCell>
                                                <DataCell>{r.user_email}</DataCell>
                                                <DataCell>{r.creator_id}</DataCell>
                                                <DataCell>{r.locale}</DataCell>
                                                <DataCell>{r.shop_name} {r.name}</DataCell>
                                            </DataRow>
                                        })}
                                    </DataBody>
                                </DataTable>
                            </GridCell>
                        }
                    </Grid>
                </StyledDiv>
            </React.Fragment>
        )
    }
}

const StyledDiv = css('div')({
    ' h3': {
        marginBottom: '10px',
    },
    ' h2': {
        paddingBottom: '20px',
    },
    ' #sql-code': {
        fontFamily: 'monospace',
        borderLeft: '4px solid ' + Theme.steelblue,
        paddingLeft: '10px',
    },
    ' .p': {
        paddingLeft: '20px',
    },
    ' img.preview-img': {
        maxWidth: '80px',
        maxHeight: '80px',
        border: '1px solid gray',
    },
    ' .center': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' .toggle-show': {
        cursor: 'pointer',
    },
    background: '#efefef',
    padding: '5px',
})

export default FindBy